import React from 'react';

/** Applies the selected classNames to `document.body`. */
export function useClassName(element: HTMLElement, ...classNames: string[]) {
	React.useEffect(() => {
		classNames.forEach((x) => element.classList.add(x));
		return () => classNames.forEach((x) => element.classList.remove(x));
	}, [classNames]);
}
